<div class="bg-white rounded-2xl border border-[#E7EAF0] p-6 mb-4 shadow-sm">
    <!-- Header -->
    <div class="flex justify-between items-start">
        <div class="flex space-x-4">
            <!-- Avatar -->
            <ngx-skeleton-loader class="w-12 h-12" appearance="circle"></ngx-skeleton-loader>

            <div class="flex flex-col space-y-2">
                <!-- Name + Type -->
                <div class="flex items-center space-x-2">
                    <ngx-skeleton-loader class="w-28 h-4 rounded-md"></ngx-skeleton-loader>
                    <ngx-skeleton-loader class="w-16 h-4 rounded-full"></ngx-skeleton-loader>
                </div>

                <!-- Time + Privacy -->
                <div class="flex items-center space-x-2">
                    <ngx-skeleton-loader class="w-20 h-3 rounded-md"></ngx-skeleton-loader>
                    <ngx-skeleton-loader class="w-5 h-3 rounded-sm"> </ngx-skeleton-loader>
                </div>
            </div>
        </div>

        <ngx-skeleton-loader class="w-4 h-4 rounded"></ngx-skeleton-loader>
    </div>

    <!-- Content -->
    <div class="mt-4 space-y-2">
        <ngx-skeleton-loader class="w-full h-3 rounded-md"></ngx-skeleton-loader>
        <ngx-skeleton-loader class="w-5/6 h-3 rounded-md"></ngx-skeleton-loader>
        <ngx-skeleton-loader class="w-2/3 h-3 rounded-md"></ngx-skeleton-loader>
    </div>

    <!-- Divider -->
    <hr class="my-4 border-[#E7EAF0]" />

    <!-- Actions / Counts -->
    <div class="flex justify-between items-start">
        <div class="flex space-x-6">
            <div class="flex items-center space-x-1">
                <ngx-skeleton-loader class="w-4 h-4 rounded-sm"></ngx-skeleton-loader>
                <ngx-skeleton-loader class="w-6 h-4 rounded-sm"></ngx-skeleton-loader>
            </div>
            <div class="flex items-center space-x-1">
                <ngx-skeleton-loader class="w-4 h-4 rounded-sm"></ngx-skeleton-loader>
                <ngx-skeleton-loader class="w-6 h-4 rounded-sm"></ngx-skeleton-loader>
            </div>
            <div class="flex items-center space-x-1">
                <ngx-skeleton-loader class="w-4 h-4 rounded-sm"></ngx-skeleton-loader>
                <ngx-skeleton-loader class="w-6 h-4 rounded-sm"></ngx-skeleton-loader>
            </div>
        </div>

        <ngx-skeleton-loader class="w-4 h-4 rounded"></ngx-skeleton-loader>
    </div>
</div>
